const state = {
  robots: [],
  robotsEventId: undefined, // event_id que a lista cacheada representa (undefined = não carregada)
  currentRobot: {},
  eventRobotCount: 0
}

export default state
